import { render, staticRenderFns } from "./ImportDepartmentSelector.vue?vue&type=template&id=1c2145c4&scoped=true"
import script from "./ImportDepartmentSelector.vue?vue&type=script&lang=js"
export * from "./ImportDepartmentSelector.vue?vue&type=script&lang=js"
import style0 from "./ImportDepartmentSelector.vue?vue&type=style&index=0&id=1c2145c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2145c4",
  null
  
)

export default component.exports